import styled from "styled-components";
import { hexToRgba } from "../../../../../themes/hex-to-rgba";

export const VideoSoundButtonDefaultBox = styled.div`
    padding: 0.25rem;
    background: ${({theme}) => hexToRgba(theme.colors.background.toString(), 0.9) };
    border-radius: 50%;
`;
